import React, { useEffect } from 'react'

import Apptentive from 'helpers/apptentive'
import GA4 from 'helpers/ga4'
import { useSessionContext } from 'hooks/SessionContext'

import HEHMModal from 'pages/shared/HEHMModal'

type Props = {
  closeCallback: (reloadPage) => void
  channel: string
}

const HEHMAcceptModal = ({ closeCallback, channel }: Props) => {
  const { session } = useSessionContext()

  useEffect(() => {
    Apptentive.sendEvent('pmk_acct_created')

    GA4.sendEvent({
      action: 'PMK Account Activated',
      category: 'PMK Settings',
      label: `Channel: ${channel}`
    })
  }, [channel, session])

  return (
    <HEHMModal closeCallback={closeCallback} />
  )
}

export default HEHMAcceptModal
